import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { BottomNavigationItemInterface, NgxBottomNavigationService } from '@digipay/ngx-bottom-navigation';
import { TransactionsApiService } from '@client-monorepo/payment/transactions';
import { AbTestService } from '@client-monorepo/common/utilities';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterAnimation } from '@client-monorepo/common/animations';

@Component({
  selector: 'dpx-with-navigation',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './with-navigation.component.html',
  styleUrl: './with-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  animations: RouterAnimation,
})
export class WithNavigationComponent implements OnInit {
  bottomNavigationService = inject(NgxBottomNavigationService);
  transactionApiService = inject(TransactionsApiService);
  paymentBadge = signal<string | undefined>(undefined);
  untilDestroy = inject(DestroyRef);
  routeContext = inject(ChildrenOutletContexts);
  navigationItems = computed<Array<BottomNavigationItemInterface>>(() => {
    let storeBadge: Partial<BottomNavigationItemInterface> = {
      iconBadge: {
        icon: {
          name: 'discount',
          type: 'due',
          secondaryColor: '#F9441F',
          size: '16px',
        },
        badge: {
          size: 'sm',
          status: 'error',
          hasCircularIcon: true,
        },
      },
    };
    if (new Date().getTime() < 1745785799000) {
      storeBadge = {
        badge: 'حراج',
      };
    }
    let items: BottomNavigationItemInterface[] = AbTestService.isShowHome()
      ? [
          {
            title: 'خانه',
            icon: 'home',
            route: '/home',
          },
        ]
      : [];
    items = items.concat([
      {
        title: 'خدمات',
        icon: 'more',
        route: '/hub',
      },
      {
        title: 'فروشگاه‌ها',
        icon: 'bag',
        route: '/stores',
        ...storeBadge,
      },
      {
        title: 'پرداخت',
        icon: 'card-to-card',
        route: '/transactions',
        badge: this.paymentBadge(),
      },
      {
        title: 'پروفایل',
        icon: 'person',
        route: '/profile',
      },
    ]);
    return items;
  });

  ngOnInit() {
    this.updateNavigationService();
    this.getInstallments();
  }

  prepareRoute() {
    return this.routeContext.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }

  private getInstallments(): void {
    this.transactionApiService
      .getUpcomingInstallmentTransactions()
      .pipe(takeUntilDestroyed(this.untilDestroy))
      .subscribe({
        next: (result) => {
          this.paymentBadge.set(result.paymentList?.length ? result.paymentList.length.toString() : undefined);
          this.updateNavigationService(true);
        },
        error: () => {
          this.updateNavigationService(true);
        },
      });
  }

  updateNavigationService(optional = false): void {
    this.bottomNavigationService.setItems(this.navigationItems());
    this.bottomNavigationService.findActiveItem();
    if (optional) {
      // check if bottom navigation is currently visible or not, because of some inner pages that hide bottom navigation
      if (this.bottomNavigationService.isVisible()) {
        this.bottomNavigationService.show();
      }
    } else {
      this.bottomNavigationService.show();
    }
  }
}
